import "core-js/modules/es.string.big.js";
export var CheckboxSize;
(function (CheckboxSize) {
  CheckboxSize[CheckboxSize["default"] = 16] = "default";
  CheckboxSize[CheckboxSize["big"] = 24] = "big";
})(CheckboxSize || (CheckboxSize = {}));
//# sourceMappingURL=types.js.map